// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tab-option_wrapper__2BK9H","active":"tab-option_active__ia8hi","center":"tab-option_center__SGPcL"};